// importing types from constants definded in constant/ index file
import {
  TOASTER_SHOW,
  TOASTER_HIDE,
  LOADER_SHOW,
} from "../constant/index";

const INITIAL_STATE = {
  show: false,
  type: "",
  heading: "",
  description: [],
  autoHide: false,
};

export default (state = INITIAL_STATE, action) => {
  const payload = action.payload;
  switch (action.type) {
    case TOASTER_SHOW: {
      const raw = payload?.description;
      let description = [];
      if (Array.isArray(raw)) {
        description = raw;
      } else if (typeof raw === "string") {
        description = raw.split(/<br\s*\/?>/i);
      } else if (raw != null) {
        description = [String(raw)];
      }
      return {
        ...state,
        ...payload,
        description,
      };
    }
    case TOASTER_HIDE:
      return INITIAL_STATE;
    case LOADER_SHOW:
      return INITIAL_STATE;
  }
  return state;
};
